import React from 'react';
import { Navbar } from "react-bootstrap";
import './web-capture-layout.css'


export default function Footer() {
    return ( <></>);
}